/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 7/29/19.
 */

function ContentSubscriptionFilterModalComponent(
    this: JS5Object,
    SearchFilterService: JS5Object,
    SubscriptionsService: JS5Object
) {

    //===================//
    // Template Bindings //
    //===================//

    this.onSeasonSelected = () => {
        this.selectedVolume = null;
    };

    this.onVolumeSelected = () => {
        this.selectedSeason = null;
    };


    this.onOk = () => {
        let criteria = SearchFilterService.getCurrentSearchCriteria();
        if (this.selectedSeason) {
            criteria.season = SearchFilterService.extractQueryProp([this.selectedSeason], 'id');
            this.selectedVolume = null;
        } else {
            delete SubscriptionsService.queryOptions.season;
            delete criteria.season;
        }
        if (this.selectedVolume) {
            criteria.volume = SearchFilterService.extractQueryProp([this.selectedVolume], 'id');
        } else {
            delete SubscriptionsService.queryOptions.volume;
            delete criteria.volume;
        }

        this.close();
    };

    this.reset = () => {
        this.dismiss({$value: 'setToDefaults'});
    };

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getFirstObjectFromPathProp = (collection: JS5Object[], objectProp: string, pathParam: string) => {
        let selectedObjs = SearchFilterService.getObjectsFromPathProp(collection, objectProp, pathParam);
        return _.get(selectedObjs, '0');
    };

    this.$onInit = () => {
        if (_.size(this.resolve.availableSeasons) < 1) {
            this.resolve.availableSeasons = [];
        }
        if (_.size(this.resolve.availableVolumes) < 1) {
            this.resolve.availableVolumes = [];
        }
        this.selectedSeason = getFirstObjectFromPathProp(this.resolve.availableSeasons, 'id', 'season');
        this.selectedVolume = getFirstObjectFromPathProp(this.resolve.availableVolumes, 'id', 'volume');
    };

}

angular
    .module('prism-ui.components')
    .component(
        'contentSubscriptionFilterModal',
        {
            controller: ContentSubscriptionFilterModalComponent,
            templateUrl: 'components/modal/content-category-filter-modal/content-subscription-filter-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
